import React from 'react';
import { ThemeProvider } from './theme';
import { Footer, Header, ThemeToggle } from './layout';
import {
  AskSection,
  BuildSection,
  DemosSection,
  FitsSection,
  ModelsSection,
  OneHotHero,
  StartSection,
  YoursSection,
} from './solutions/onehot';
import './theme/globals.css';
import './solutions/onehot/onehot.css';

function OneHotContent() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <ThemeToggle />
      <main>
        <OneHotHero />
        <FitsSection />
        <AskSection />
        <ModelsSection />
        <DemosSection />
        <YoursSection />
        <BuildSection />
        <StartSection />
      </main>
      <Footer />
    </div>
  );
}

export function OneHotPage() {
  return (
    <ThemeProvider defaultTheme="light">
      <OneHotContent />
    </ThemeProvider>
  );
}

export default OneHotPage;
